import React from 'react'
import Typography from '@mui/material/Typography'
import {useAppSelector} from '../../store/hooks'
import timeUntilNextBreakText from './timeUntilNextBreak'

function NextBreak() {
  const nextBreakNumber = useAppSelector(schedule => schedule.nextBreakNumber)
  const breaks = useAppSelector(schedule => schedule.breaks)
  const currentBlindNumber = useAppSelector(schedule => schedule.currentBlindNumber)
  const levelLength = useAppSelector(schedule => schedule.levelLength)
  const onBreak = useAppSelector(schedule => schedule.onBreak)
  const secondsLeftInCurrentSession = useAppSelector(schedule => schedule.secondsLeftInCurrentSession)

  const nextBreak = breaks[nextBreakNumber + (onBreak ? 1 : 0)]

  const timeUntilNextBreak = timeUntilNextBreakText(nextBreak, currentBlindNumber, levelLength, secondsLeftInCurrentSession)

  return (
    <Typography component="div">{nextBreak ? `Break @ ~${timeUntilNextBreak}` : 'No further breaks'}</Typography>
  )
}

export default NextBreak
